import React from "react";
import { Form, Input } from "antd";

export const InvoiceNumberField: React.FC = () => {
  const language = Form.useWatch("language");

  const label = language === "es" ? "Número de Factura" : "Invoice Number";

  return (
    <div>
      <div className="font-bold text-green-600 mb-1">{label}</div>

      <Form.Item name="invoiceNumber" className="mb-0">
        <Input disabled className="text-right" />
      </Form.Item>
    </div>
  );
};
